export default __webpack_public_path__ + "static/media/mastercard.4116b27f.svg";